import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TeamComponent } from './team/team.component';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HealthComponent } from './health/health.component';
import { CultureComponent } from './culture/culture.component';
import { ComplainRegisterComponent } from './complain-register/complain-register.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ComplainStatusComponent } from './complain-status/complain-status.component';
import { AboutComponent } from './about/about.component';
import { GalleryComponent } from './gallery/gallery.component';
import { LoginComponent } from './login/login.component';
import { OnlineApplyComponent } from './online-apply/online-apply.component';
import { SchemesComponent } from './schemes/schemes.component';
import { SchoolComponent } from './school/school.component';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    TeamComponent,
    HomeComponent,
    HealthComponent,
    CultureComponent,
    ComplainRegisterComponent,
    ComplainStatusComponent,
    AboutComponent,
    GalleryComponent,
    LoginComponent,
    OnlineApplyComponent,
    SchemesComponent,
    SchoolComponent
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
